import { Router } from 'director/build/director';
import { reaction } from 'mobx';
import queryString from 'query-string';
import Notifications from './utils/notification-helper';
import _ from 'lodash';
import Cons from '../isomorphic/cons';

export default class SkyTCAdminRouter {
    appStore;
    router;

    constructor(appStore) {
        this.appStore = appStore;
    }

    init() {
        this.router = new Router({
            '/returnRoute': () => {
                const redirectUrl = localStorage.getItem('aqbx-redirect-url');
                if (redirectUrl) {
                    window.location.href = redirectUrl;
                } else {
                    this.appStore.viewStore.openFilesPage();
                }

                localStorage.removeItem('aqbx-redirect-url');
            },
            '/dashboard': this.appStore.viewStore.openDashBoardPage,
            '/files': this.appStore.viewStore.openFilesPage,
            '/files/makelisting': this.appStore.viewStore.openAddListingToPrimePage,
            '/files/maketransaction': this.appStore.viewStore.openAddTransactionToPrimePage,
            '/filedetail/:fileId': (fileId) => this.appStore.viewStore.openFileDetailPageById(fileId),
            '/reports': this.appStore.viewStore.openReportsPage,
            '/coordinators': this.appStore.viewStore.openCoordinatorsPage,
            '/emailtemplates': () => this.appStore.viewStore.openEmailTemplatesPage(),
            '/agents': () => {
                this.appStore.viewStore.openAgentsPage();
            },
            '/sales/agents': () => {
                this.appStore.viewStore.openSalesPage();
            },
            '/agentprofile/:agentId': (agentId) =>
                this.appStore.viewStore.openAgentProfilePageById(Cons.pages.agents, agentId),
            '/callback': () => {
                let parsedQueryString = queryString.parse(window.location.hash.split('?')[1]);
                this.appStore.viewStore.handleAuth(parsedQueryString);
            },
            '/auth': () => {
                this.appStore.authStore.signIn();
            },
            '/logout': () => {
                this.appStore.authStore.clearAuth();
            },
            '/link/failure': () => {
                Notifications.ToastError('Failed to link account.  Please contact the SkyTC dev team.');
                this.appStore.viewStore.openFilesPage();
            },
        })
            .configure({
                // notfound: this.appStore.viewStore.openFilesPage,
                html5history: false,
            })
            .init();

        reaction(
            () => this.appStore.viewStore.currentUrl,
            (path) => {
                if (!this.appStore.authStore.isAuthenticated()) {
                    this.appStore.authStore.signIn();
                } else if (path === '/') {
                    // only log to segment when we're authed
                    this.appStore.analytics.page(this.pageName(path), { path: this.removeLeading(path, '#') });
                    this.appStore.coordinatorDetailStore.loadCurrentCoordinator();
                    this.appStore.viewStore.openDefaultPage();
                } else {
                    // only log to segment when we're authed
                    this.appStore.analytics.page(this.pageName(path), { path: this.removeLeading(path, '#') });
                    this.appStore.coordinatorDetailStore.loadCurrentCoordinator();
                    if (window.location.pathname !== path) window.history.pushState(null, null, path);
                }
            },
            { fireImmediately: true, this: this }
        );
    }

    removeLeading(path, char) {
        return _.startsWith(path, char) ? path.slice(1) : path;
    }

    pageName(path) {
        // I don't like this but I don't have a better way right now
        const idPages = ['agentprofile', 'filedetail'];
        const pathParts = this.removeLeading(this.removeLeading(path, '#'), '/').split('?')[0].split('/');
        return idPages.includes(pathParts[0].toLowerCase()) ? pathParts[0] : _.last(pathParts);
    }
}



// WEBPACK FOOTER //
// ./src/router.js